import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase, { auth } from "../../lib/firebase";
import Utils from "../../Utils";
import ar from "../../locale";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import MatchesTableRow from "../MatchesTableRow";
moment.locale("en");

export default class MatchesTable extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      token: null,
      matches: {},
      unfilterdMatches: {},
    };
    this.matchRef = firebase.database().ref("matches/");
  }

  componentDidMount() {
    super.componentDidMount();
    let { showfinished } = this.props;
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    if (this.props.club) {
      let { club } = this.props;
      this.matchRef
        .orderByChild("team1")
        .equalTo(club.key)
        .on("value", (response) => {
          let matches = response.val();
          Object.assign(this.state.unfilterdMatches, matches);
          this.filterMatches(showfinished);
        });
      this.matchRef
        .orderByChild("team2")
        .equalTo(club.key)
        .on("value", (response) => {
          let matches = response.val();
          Object.assign(this.state.unfilterdMatches, matches);
          this.filterMatches(showfinished);
        });
    } else {
      this.matchRef.orderByChild("team1").on("value", (response) => {
        let matches = response.val();
        Object.assign(this.state.unfilterdMatches, matches);
        this.filterMatches(showfinished);
      });
      this.matchRef.orderByChild("team2").on("value", (response) => {
        let matches = response.val();
        Object.assign(this.state.unfilterdMatches, matches);
        this.filterMatches(showfinished);
      });
    }
    window.Tablesaw.init(this.$("#sawtable"));
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.matchRef.off();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  filterMatches = (showFinished = false) => {
    this.state.matches = {};
    for (var key in this.state.unfilterdMatches) {
      let match = this.state.unfilterdMatches[key];
      if (showFinished) {
        this.state.matches[key] = match;
      } else {
        if (!match.finished) {
          this.state.matches[key] = match;
        } else {
          delete this.state.matches[key];
        }
      }
    }
    this.updateState();
  };

  //Callback grom child
  onDelete = (match) => {
    delete this.state.unfilterdMatches[match.key];
    this.filterMatches(this.props.showfinished);
  };

  renderMatches = (match, index) => {
    return (
      <MatchesTableRow match={match} key={match.key} onDelete={this.onDelete} />
    );
  };

  render() {
    let matches = Utils.convertToArrayWithOrderKeyAsc(this.state.matches, "on");
    return (
      <div>
        {matches &&
          matches.length > 0 &&
          matches.map((match, index) => this.renderMatches(match, index))}
        {matches && matches.length === 0 && <p>{ar.section_empty}</p>}
      </div>
    );
  }
}
